import React from 'react';
import {
  Form,
  Button,
  Row,
  Col,
} from 'react-bootstrap';
import { Formik, FormikHelpers } from 'formik';
import { Link } from '../../types/Link';

interface LinkFormProps {
  initialValues: Link;
  onSave: (link: Link) => void;
  onCancel: () => void;
}

export default function LinkForm({ initialValues, onSave, onCancel }: LinkFormProps) {
  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={(values: Link, { setSubmitting }: FormikHelpers<Link>) => {
        onSave(values);
        setSubmitting(false);
      }}
    >
      {(formik) => (
        <Form onSubmit={formik.handleSubmit}>
          {/* German Section */}
          <div className="border-bottom pb-4 mb-4">
            <h5 className="mb-3">German Version</h5>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="title">
                  <Form.Label>Title (DE)</Form.Label>
                  <Form.Control
                    type="text"
                    {...formik.getFieldProps('title')}
                  />
                </Form.Group>
                <Form.Group controlId="url">
                  <Form.Label>URL (DE)</Form.Label>
                  <Form.Control
                    type="url"
                    {...formik.getFieldProps('url')}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>

          {/* French Section */}
          <div className="border-bottom pb-4 mb-4">
            <h5 className="mb-3">French Version</h5>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="title_fr">
                  <Form.Label>Title (FR)</Form.Label>
                  <Form.Control
                    type="text"
                    {...formik.getFieldProps('title_fr')}
                  />
                </Form.Group>
                <Form.Group controlId="url_fr">
                  <Form.Label>URL (FR)</Form.Label>
                  <Form.Control
                    type="url"
                    {...formik.getFieldProps('url_fr')}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>

          {/* Italian Section */}
          <div className="mb-4">
            <h5 className="mb-3">Italian Version</h5>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="title_it">
                  <Form.Label>Title (IT)</Form.Label>
                  <Form.Control
                    type="text"
                    {...formik.getFieldProps('title_it')}
                  />
                </Form.Group>
                <Form.Group controlId="url_it">
                  <Form.Label>URL (IT)</Form.Label>
                  <Form.Control
                    type="url"
                    {...formik.getFieldProps('url_it')}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={onCancel}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}
